import Button from '@mui/material/Button';
import { colors, layout } from '../tokens';

/**
 * PrimaryButton — reusable CTA button used for Subscribe, Unsubscribe,
 * Top Up, Save, Continue, and other primary actions across the app.
 *
 * Props (all optional):
 *   colorVariant: 'primary' | 'success' | 'danger'  (default: 'primary')
 *   sx: MUI sx overrides — merged on top of base styles, always wins
 *   ...any native MUI Button props (variant, onClick, disabled, type, etc.)
 */
const bgMap = {
  primary: colors.primary.main,
  success: colors.success.main,
  danger: colors.error.main,
};

const PrimaryButton = ({ colorVariant = 'primary', sx, ...props }) => {
  const bg = bgMap[colorVariant] || colors.primary.main;

  const baseSx = {
    backgroundColor: bg,
    color: colors.primary.contrastText,
    fontSize: '15px',
    fontWeight: 500,
    height: `${layout.actionButtonHeight}px`,
    borderRadius: '8px',
    letterSpacing: '.6px',
    padding: '10px 20px',
    textTransform: 'none',
    width: '100%',
    maxWidth: '393px',
    '&:hover': {
      backgroundColor: bg,
      boxShadow: 'none',
    },
    '&:disabled': {
      backgroundColor: colors.text.disabled,
      color: colors.background.paper,
    },
  };

  return (
    <Button
      {...props}
      sx={[baseSx, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
};

export default PrimaryButton;